$(document).ready(function() {
    $('.js_slider').each((i,el) => {
        let duration
        if ( parseFloat($(el).attr('data-duration')) > 0 ) {
            duration = {
                delay: $(el).attr('data-duration') * 1000
            }
        } else {
            duration = {
                enabled: false
            }
        }
        new Swiper(el, {
            slidesPerView: 1,
            loop: true,
            autoplay: duration,
            navigation: {
                prevEl: '.js_slider__prev',
                nextEl: '.js_slider__next'
            },
            pagination: {
                el: '.js_slider__pagi',
                bulletClass: 'slider__pagi-item',
                bulletActiveClass: 'active'
            }, 
            modules: [SwiperModes.Navigation, SwiperModes.Autoplay, SwiperModes.Pagination]
        })
        sliderNavPosition(el)
    })
})

$(window).on('resize', function() {
    $('.js_slider').each((i,el) => {
        sliderNavPosition(el)
    })
})

$(document).on('click', '.js_slider__anchor', function() {
    let partners = $('.js_partners')
    if (partners.length) {
        let positionTop = partners.offset().top - 90
        window.scrollTo({
            top: positionTop,
            behavior: 'smooth'
          });
    }
})

function sliderNavPosition(el) {
    let right = $(el).find('.js_slider__content-wrapper').offset().left + parseInt($(el).find('.js_slider__content-wrapper').css('padding-left'))
    $(el).find('.js_slider__nav').css('right', right)
    $(el).find('.js_slider__pagi').css('right', right)
}